import * as React from "react";
import { useDispatch } from "redux-react-hook";

import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text/Text";
import { updateCustomerReference } from "src/core/orders/store/orders.actions";
import { updateCustomerReference as updateCustomerReferenceList } from "src/core/lists/store/lists.actions";
import useDrop from "src/core/drops/hooks/useDrop";
import { poNumberIsValid } from "src/core/orders/utils/orders";

import { StyledInput } from "../InputFields";
import { TPurchaseOrderNumberType } from "./PurchaseOrderNumberTypes";

interface IProps {
  type: TPurchaseOrderNumberType;
}

const AddPurchaseOrderNumber: React.ReactFCWithChildren<IProps> = ({ type }) => {
  const [ showPONumber, setShowPONumber ] = React.useState(false);
  const [ poNumber, setPONumber ] = React.useState<string>();
  const [ poError, setPOError ] = React.useState<string | null>(null);
  const dispatch = useDispatch();
  const [ { drop } ] = useDrop();

  const updatePONumber = () => {
    if (poNumber) {
      setShowPONumber(false);

      if (type === "order") {
        dispatch(updateCustomerReference(poNumber));
      }

      if (type === "list") {
        dispatch(updateCustomerReferenceList(poNumber));
      }
    }
  };

  return (
    <div>
      {showPONumber ? (
        <>
          <StyledInput
            onChange={e => {
              setPONumber(e.target.value);

              if (drop) {
                const poNumberError = poNumberIsValid(e.target.value, drop);

                setPOError(poNumberError);
              }
            }}
            value={poNumber}
          />

          {poError && (
            <Text color="error">
              {poError}
            </Text>
          )}

          <Button
            loading={false}
            disabled={!!poError}
            onClick={() => updatePONumber()}
          >
            Confirm
          </Button>
        </>
      ) : (
        <Button
          loading={false}
          onClick={() => setShowPONumber(true)}
        >
          Add
        </Button>
      )}
    </div>
  );
};

export default AddPurchaseOrderNumber;
